/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_File_Too_Much_TextInputs */

const en_issue_file_too_much_text = /** @type {(inputs: Issue_File_Too_Much_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`holds more text than an import can read`)
};

/**
* | output |
* | --- |
* | "holds more text than an import can read" |
*
* @param {Issue_File_Too_Much_TextInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_file_too_much_text = /** @type {((inputs?: Issue_File_Too_Much_TextInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_File_Too_Much_TextInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_file_too_much_text(inputs)
});